import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Чи проводите ви первинний аналіз справи?',
  answer: 'Так, під час первинного звернення ми коротко розбираємо вашу ситуацію, оцінюємо наявні документи та визначаємо юридичні перспективи справи й можливі ризики.'
}, {
  question: 'Як зафіксовані ціни на послуги та чи не зростуть вони в процесі роботи?',
  answer: 'Усі умови та вартість послуг фіксуються в офіційному договорі про надання правової допомоги. Сума залишається незмінною, жодних прихованих платежів чи непередбачених доплат немає.'
}, {
  question: "Чи обов'язково мені особисто ходити в суди, ТЦК або інші держоргани?",
  answer: 'У більшості випадків ваша особиста присутність не потрібна. Я дію на підставі ордера та договору: особисто подаю заяви, беру участь у судових засіданнях та представляю ваші інтереси в державних органах.'
}, {
  question: 'Чи працюєте ви дистанційно, якщо я перебуваю в іншому місті чи за кордоном?',
  answer: 'Так, я працюю по всій Україні та з клієнтами за кордоном. Усі документи, ордери та процесуальні папери підписуються електронним цифровим підписом (ЕЦП) або надсилаються поштою.'
}, {
  question: 'Які гарантії ви даєте, що справа буде виграна?',
  answer: 'Законом України «Про адвокатуру та адвокатську діяльність» та Етикою адвоката заборонено гарантувати 100% результат у суді. Проте я гарантую чесну та професійну оцінку шансів, дотримання всіх процесуальних строків і максимальний захист ваших інтересів у межах закону.'
}, {
  question: 'Чи гарантується повна конфіденційність мого звернення?',
  answer: 'Абсолютно. Будь-яка інформація, передана мені клієнтом, захищена адвокатською таємницею. Вона не підлягає розголошенню та не може бути витребувана третіми особами чи правоохоронними органами.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-background" data-id="element-69" data-mp="2ku3pau2bsqsp">
      <div className="max-w-3xl mx-auto px-6" data-id="element-70" data-mp="2fxvettz2plrv">
        <div className="text-center mb-16" data-id="element-71" data-mp="2fuhcglqetckf">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-72" data-mp="2ayikyp9sbefs">
            Поширені запитання
          </h2>
        </div>

        <div className="space-y-4" data-id="element-73" data-mp="38kzfjmr4vdxu">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-border rounded-2xl overflow-hidden bg-surface" data-id="element-74" data-mp="33ng2gq66977h" data-mpi={index}>
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-75" data-mp="3uupqr0g6s4kb">
                <span className="font-medium text-primary pr-4" data-id="element-76" data-mp="7oynma3kqbg6">
                  {faq.question}
                </span>
                <ChevronDown className={`text-secondary transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-77" data-mp="cgp46xt3tvg1" />
              </button>
              <AnimatePresence data-id="element-78" data-mp="mfxungorgrxn">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-79" data-mp="qghr0i1ifriq">
                    <div className="px-6 pb-5 text-secondary leading-relaxed border-t border-border/50 pt-4" data-id="element-80" data-mp="2bup3z14axq8q">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}